const reviews = [
  {
    stars: 5,
    title: '직접 오셔서 꼼꼼하게 챙겨주셨어요',
    excerpt: '이사 당일 대표님께서 직접 나오셔서 처음부터 끝까지 챙겨주셨어요. 가구 하나하나 꼼꼼하게 포장해주시고, 새 집에서 배치까지 도와주셔서 정말 감동받았습니다. 덕분에 하나도 긁히지 않고 이사 잘 마쳤어요. 다음에도 꼭 이용할게요!',
    link: '/after'
  },
  {
    stars: 5,
    title: '강원도에서 수도권까지 정말 믿고 맡겼어요',
    excerpt: '강원도에서 서울로 장거리 이사였는데 걱정이 많았는데 상담부터 이사 완료까지 너무 친절하고 신속하게 처리해주셨어요. 짐도 하나도 손상 없이 무사히 도착했고, 가격도 합리적이었습니다. 강력 추천드립니다!',
    link: '/after'
  },
  {
    stars: 5,
    title: '사무실 이사인데도 하루 만에 깔끔하게 완료!',
    excerpt: '작은 사무실 이전이었는데 책상·캐비닛·전산장비까지 꼼꼼하게 포장해서 옮겨주셨어요. 직원들이 업무 공백 없이 다음 날 바로 출근할 수 있었습니다. 진짜 프로답게 일하셨고 너무 만족스러워요.',
    link: '/after'
  },
  {
    stars: 5,
    title: '이사도 신속히 잘 되고, 너무 친절했어요',
    excerpt: '양 쪽 엘리베이터 이사라 시간이 오래 걸리진 않을까 걱정했는데, 이모님 포함 총 7분이 오셨고 다들 베테랑이신지 손발이 척척 맞고 신속하시더라구요. 마무리 청소까지 깔끔하게 해주셔서 너무 감사했습니다.',
    link: '/after'
  }
];

export default function Reviews() {
  return (
    <section id="reviews" className="py-14 md:py-20 px-4 md:px-6 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-lg md:text-4xl font-extrabold text-center mb-8 md:mb-12 text-gray-950 whitespace-nowrap">
          왜 <span className="text-teal-600">우리집 익스프레스를 선택</span>했을까?
        </h2>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6">
          {reviews.map((review, index) => (
            <a
              key={index}
              href={review.link}
              className="bg-white p-4 md:p-6 rounded-lg hover:shadow-sm transition-shadow cursor-pointer"
            >
              <div className="flex gap-0.5 mb-2">
                {[...Array(review.stars)].map((_, i) => (
                  <span key={i} className="text-yellow-400 text-base">★</span>
                ))}
              </div>
              <h3 className="text-base font-bold text-gray-950 mb-2 line-clamp-2">
                {review.title}
              </h3>
              <p className="text-sm text-gray-700 line-clamp-3 whitespace-pre-line font-medium">
                {review.excerpt}
              </p>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
